const breakpoints = {
	tablet: `min-width: 760px`,
	laptopS: `min-width: 1024px`,
	laptopL: `min-width: 1440px`,
};

export default breakpoints;
